import * as React from "react";
import { SubAccountType } from "../../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { FinancialAdvice } from "../../../Common/PaymentsIn/FinancialAdvice";
import { SinglePayment } from "../../../Common/PaymentsIn/SinglePayment/SinglePayment";
import { MoneyPurchaseAnnualAllowanceComponent } from "../../../Common/PaymentsIn/SIPP/MoneyPurchaseAnnualAllowanceComponent";
import { PensionProtection } from "../../../Common/PaymentsIn/SIPP/PensionProtection";
import { SourceOfWealth } from "../../../Common/PaymentsIn/SIPP/SourceOfWealth";
import { TransferIn } from "../../../Common/PaymentsIn/TransferIn/TransferIn";
import { PaymentType, processTypeEnum } from "../../../Common/Resource/Contents";
import { RestrictionStore } from "../../../Common/Restrictions/Variable";

interface IPaymentsInProps extends IProcessComponentProps {
    type: SubAccountType;
    data: any;
}

interface IPaymentsInState {
    transferInDisabled?: boolean;
}

export class PaymentsIn extends ProcessComponent<IPaymentsInProps, IPaymentsInState> {
    constructor(props: any) {
        super(props);
        this.state = {};
    }
    componentDidMount() {
        super.componentDidMount();
        this.setState({ transferInDisabled: RestrictionStore.transferDisabled() });
    }
    private getProps = (key) => {
        const { onChange, data, showErrorMsgPopUp, isReview } = this.props;
        return {
            data: data[key],
            onRef: (ref) => this.appendChild(ref),
            showErrorMsgPopUp: (msg, isShow) => showErrorMsgPopUp(msg, isShow),
            onChange: (changes) => this.onDataChange(onChange, changes, data, key),
            hasPaymentMethod: true,
            isReview: isReview,
        };
    };

    private renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions) {
        const { Contribution } = this.props.data;
        const { type } = this.props;
        const { onChange, data } = this.props;

        return (
            <>
                <hr />
                <MoneyPurchaseAnnualAllowanceComponent {...this.getProps("Contribution")} />
                <PensionProtection {...this.getProps("Contribution")} label={"Edit pension protection"} />
                <hr />
                <SinglePayment
                    {...this.getProps("Contribution")}
                    clientInfo={ClientDetails}
                    checkBoxOption={[PaymentType.Client, PaymentType.ThirdParty, PaymentType.Employer]}
                    hasPaymentMethod={true}
                    subAccountType={this.props.type}
                    bankAccounts={AllBankAccounts}
                    bankAccountInstructions={BankAccountInstructions}
                    processType={processTypeEnum.topUpWithITFLS}
                />
                <hr />
                {Contribution.PensionTransfers && (
                    <TransferIn
                        disabled={this.state.transferInDisabled}
                        subAccountType={type}
                        data={Contribution.PensionTransfers}
                        jouneryType={processTypeEnum.topUpWithITFLS}
                        onChange={(changes) =>
                            this.onDataChange(
                                (changes) => this.onDataChange(onChange, changes, data, "Contribution"),
                                changes,
                                data.Contribution
                            )
                        }
                        showErrorMsgPopUp={this.props.showErrorMsgPopUp}
                        isPost={false}
                        isReview={this.props.isReview}
                        onRef={(ref) => this.appendChild(ref)}
                        accountServiceProposition={this.props.data.AccountServiceProposition}
                    />
                )}
                {Contribution.ClientSinglePayment && Contribution.ClientSinglePayment !== null && (
                    <SourceOfWealth {...this.getProps("Contribution")} />
                )}
            </>
        );
    }

    public render(): JSX.Element {
        const { ClientDetails, AllBankAccounts, Contribution, BankAccountInstructions } = this.props.data;
        const { type } = this.props;
        return (
            <div>
                <h2>Payments in</h2>
                <FinancialAdvice {...this.getProps("Contribution")} />
                {Contribution?.AdviceGiven &&
                    this.renderPaymentsIn(ClientDetails, AllBankAccounts, BankAccountInstructions)}
            </div>
        );
    }
}
